import type { DepartmentLoginRecord } from '@navio/nsdk';
import { useSelectedDepartmentIds } from '../stores/customerDepartmentStore';
import { useUserGroupSelection } from './useUserGroupSelection';

export const useCustomerDepartmentSelection = () => {
  const { selectedUserGroup, userData } = useUserGroupSelection();
  const selectedDepartmentIds = useSelectedDepartmentIds();
  const getSelectedDepartmentForGroup = (userGroupId: number): DepartmentLoginRecord | undefined => {
    if (!userData) {
      return undefined;
    }
    const departments = userData.user.userGroups.find((group) => group.id === userGroupId)?.departments ?? [];
    const selectedDepartmentId = selectedDepartmentIds[`${userData.user.id}:${userGroupId}`];
    return departments.find((department) => department.id === selectedDepartmentId) ?? departments[0];
  };
  const selectedDepartment = selectedUserGroup ? getSelectedDepartmentForGroup(selectedUserGroup.id) : undefined;

  return { selectedDepartment, getSelectedDepartmentForGroup };
};
